import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import Login from './components/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import WeddingsList from './pages/weddings/WeddingsList';
import WeddingDetails from './pages/weddings/WeddingDetails';
import WeddingForm from './pages/weddings/WeddingForm';
import Settings from './pages/settings/Settings';
import UsersList from './pages/users/UsersList';
import GuestView from './pages/public/GuestView';
import QrCodeScanner from './pages/public/QrCodeScanner';
import Layout from './components/layout/Layout';

// Protected Route component
const ProtectedRoute = ({ children, requireAdmin }) => {
  const { currentUser, userData } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (requireAdmin && !userData?.isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

const App = () => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/wedding/:weddingId/guest" element={<GuestView />} />
              <Route path="/qr/:weddingId" element={<QrCodeScanner />} />

              {/* Protected routes with Layout */}
              <Route element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/weddings" element={<WeddingsList />} />
                <Route path="/weddings/create" element={<WeddingForm />} />
                <Route path="/weddings/edit/:weddingId" element={<WeddingForm />} />
                <Route path="/weddings/:weddingId" element={<WeddingDetails />} />
                <Route path="/settings" element={<Settings />} />
                
                {/* Admin routes */}
                <Route path="/users" element={
                  <ProtectedRoute requireAdmin={true}>
                    <UsersList />
                  </ProtectedRoute>
                } />
              </Route>

              {/* Catch all - redirect to dashboard */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </AuthProvider>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
